import { takeLatest, put, call } from 'redux-saga/effects';

import { listMotoristaCadastro } from '../service';
import {
  TABLE_MOTORISTA_CADASTRO,
  TABLE_MOTORISTA_CADASTRO_PENDING,
  TABLE_MOTORISTA_CADASTRO_SUCCESS,
  TABLE_MOTORISTA_CADASTRO_FAILURE
} from '../actionTypes';

function* sagaListMotoristaCadastro(action) {
  yield put({ type: TABLE_MOTORISTA_CADASTRO_PENDING })

  try {
    const table = yield call(listMotoristaCadastro, action.args)
    yield put({ type: TABLE_MOTORISTA_CADASTRO_SUCCESS, table: table })

  } catch (error) {

    yield put({ type: TABLE_MOTORISTA_CADASTRO_FAILURE })
    // console.error(error) // eslint-disable-line

  }
}

export default function* watchListMotoristaCadastro() {
  yield takeLatest(TABLE_MOTORISTA_CADASTRO, sagaListMotoristaCadastro)
}